import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import * as Rx from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import { GlobalNotificationsProvider } from '../../providers/global-notifications/global-notifications';
/*
  Generated class for the WebSocketProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WebSocketProvider {
  private sessionID;
  private socket;
  constructor(
    public http: HttpClient,
    private globalNotifications: GlobalNotificationsProvider
  ) {}

  initSocket(sessionId, uuid): void {
    this.sessionID = sessionId;
    this.socket = io('https://dev.matchabout.com:443', {
      query: 'sessionId=' + sessionId + '&user.uuid=' + uuid,
      transports: ['websocket'],
    });
    this.globalNotifications.checkNewMessages().subscribe((response: any) => {
      for (const message of response) {
        this.globalNotifications.notificationActions(message);
      }
    });
    this.socket.on('reconnect_attempt', () => {
      this.socket.io.opts.transports = ['polling', 'websocket'];
    });
  }

  onMessage(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('event', data => {
        observer.next(data);
      });
    });
  }

  checkSub() {
    this.socket.on('CHECK', (data, callback, arg1) => {
      this.globalNotifications.checkNewMessages().subscribe((response: any) => {
        for (const message of response) {
          this.globalNotifications.notificationActions(message);
        }
      });
      callback('server message was delivered to client!');
    });
  }
  /* We can have multiple events in no time, this is pattern take takes event
   @argument and creates observable to listen on that socket  */

  onEvent(event: Event): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on(event, () => observer.next());
    });
  }
  event(event, callback): void {
    this.socket.on(event, callback);
  }
}



// WEBPACK FOOTER //
// ./src/providers/web-socket/web-socket.ts